import ErrorHandler from './utils/error-handler';
import { toast } from 'react-toastify';
import { HttpUtil } from '@graffer-inc/graffer-ui';


export const client = HttpUtil.getClient();

export const ENDPOINT = {
  EL_CERT: {
    ENTRIES: '/api/e-cert/v1/entries',
    ENTRY: id => `/api/e-cert/v1/entries/${id}`,
    ENTRY_USER_VOICE: id => `/api/e-cert/v1/entries/${id}/user-voice`,
    REGISTRY_OFFICE: id => `/api/e-cert/v1/entries/${id}/registry-office`,
    REGISTER_ISSUE_INFO: id => `/api/e-cert/v1/entries/${id}/issue-info`,
    ENTRY_EL_CERT: id => `/api/e-cert/v1/entries/${id}/el-cert`,
    ENTRY_INVOICE: (id, to) => `/api/e-cert/v1/entries/${id}/encoded-invoice?to=${to}`,
    PRICE_TABLE: '/api/e-cert/v1/price-table',
    CORPORATE_ADDRESS_SET_BY_USER: '/api/e-cert/v1/corporate-address-set-by-user',
    EMS_ALL_ENTRIES: (entryStatus, entryManagementStatus, irregularStatus) => `/api/e-cert/v1/all-entries?entryStatus=${entryStatus}&entryManagementStatus=${entryManagementStatus}&irregularStatus=${irregularStatus}`,
    EMS_ALL_ENTRY: id => `/api/e-cert/v1/all-entries/${id}`,
    EMS_ALL_ENTRY_APPLICATION_PDF: id => `/api/e-cert/v1/all-entries/${id}/application-pdf`,
    EMS_ALL_ENTRY_SHINSEI: id => `/api/e-cert/v1/all-entries/${id}/shinsei`,
    EMS_ALL_ENTRY_KEY_PAIR: id => `/api/e-cert/v1/all-entries/${id}/key-pair`,
    EMS_ALL_ENTRY_SHIP: id => `/api/e-cert/v1/all-entries/${id}/ship`,
    EMS_ALL_ENTRY_REFUND: id => `/api/e-cert/v1/all-entries/${id}/refund`,
    EMS_ALL_ENTRY_DOWNLOAD_AVAILABLE: id => `/api/e-cert/v1/all-entries/${id}/status-to-download-available`,
    ENTRY_MANAGEMENT_STATUS: id => `/api/e-cert/v1/entry-managements/${id}/status`,
    ENTRY_MANAGEMENT_STATUS_APPLY_READY: id => `/api/e-cert/v1/entry-managements/${id}/apply-ready`,
    ENTRY_MANAGEMENT_STATUS_ENTERING_SERIAL_NO: id => `/api/e-cert/v1/entry-managements/${id}/status-entering-serial-no`,
    IRREGULAR_STATUS: id => `/api/e-cert/v1/entry-managements/${id}/irregular-status`,
    ENTRY_MANAGEMENT_MEMO: id => `/api/e-cert/v1/entry-managements/${id}/memo`,
    OPS_NOTIFICATION: `/api/e-cert/v1/ops-notifications`,
    OPS_NOTIFICATION_DELETE: `/api/e-cert/v1/ops-notifications/delete`,
  },
  REGISTRY_CERTS: {
    STAMP_SUBMITTER: '/api/corporate-certs/v1/stamp-settings/stamp-submitter',
    CORPORATIONS: keyword => `/api/corporate-certs/v1/corporations?keyword=${encodeURI(keyword)}`,
  },
  ACCOUNTS: {
    COMPANY: '/api/accounts/v1/companies',
    CARD: '/api/accounts/v1/payments/card',
    SHIPPING_ADDRESSES: '/api/accounts/v1/shipping-addresses',
    CHECK_AUTH: '/api/accounts/check-auth',
    LOGOUT: '/api/accounts/v1/logout',
    EMS_CHECK_AUTH: '/api/accounts/check-auth-for-ems',
  },
  OTHER: {
    GOOGLE_MAP_ADDRESS_SEARCH: placeName => `/maps/api/place/findplacefromtext/json?input=${placeName}&inputtype=textquery&language=ja&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&fields=formatted_address`,
  },
};
const callApi = async (onCall, onSuccess = res => {}, onFail = e => {
  if (e.response) {
    ErrorHandler.common(e.response.status);
  } else {
    toast.error('ネットワークエラーが発生しました。インターネットに接続していることを確認して画面を更新してください。');
  }
}) => {
  try {
    const res = await onCall;
    onSuccess(res);
  } catch (e) {
    onFail(e);
  }
}

// sample request
// {
//   "certPeriod": 3,
//   "amount": 3218,
//   "cardId": "card_111",
//   "IsRegistryCertsRegistration": true,
//   "address": "99999999999",
//   "postalCode": "EL_CERT",
//   "receiverName": "11111111111",
//   "keyPairPass": "EL_CERT_SUPPORT",
//   "pauseCode": "this is el cert content."
// }
const entry = async (body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.EL_CERT.ENTRIES, body), onSuccess, onFail);
const notifyUserVoice = async (id, body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.EL_CERT.ENTRY_USER_VOICE(id), body), onSuccess, onFail);

// sample request
// {
//   "serialNo": "1234567890",
//   "elCertPassword": "password",
//   "versionNo": 1,
// }
const registerIssueInfo = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.REGISTER_ISSUE_INFO(id), body), onSuccess, onFail);

const fetchEntries = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.ENTRIES), onSuccess, onFail);

const fetchEntry = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.ENTRY(id)), onSuccess, onFail);

const fetchRegistryOffice = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.REGISTRY_OFFICE(id)), onSuccess, onFail);

const fetchPriceTable = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.PRICE_TABLE), onSuccess, onFail);

const fetchStampSubmitter = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.REGISTRY_CERTS.STAMP_SUBMITTER), onSuccess, onFail);

// sample request
// {
//   "corporateId": "9010401132779",
//   "companyName": "株式会社グラファー"
// }
const updateCompany = async (body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.ACCOUNTS.COMPANY, body), onSuccess, onFail);

// sample request
// {
//   "corporateId": "9010401132779",
//   "companyName": "株式会社グラファー"
// }
const updateStampSubmitter = async (body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.REGISTRY_CERTS.STAMP_SUBMITTER, body), onSuccess, onFail);
const searchCorporations = async (keyword, onSuccess, onFail) => await callApi(client.get(ENDPOINT.REGISTRY_CERTS.CORPORATIONS(keyword)), onSuccess, onFail);

const fetchCard = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.ACCOUNTS.CARD), onSuccess, onFail);
const fetchShippingAddress = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.ACCOUNTS.SHIPPING_ADDRESSES), onSuccess, onFail);

const fetchLoginAccount = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.ACCOUNTS.CHECK_AUTH), onSuccess, onFail);
const logout = async (onSuccess, onFail) => await callApi(client.post(ENDPOINT.ACCOUNTS.LOGOUT, {}), onSuccess, onFail);

const upsertCorporateAddressSetByUser = async (body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.EL_CERT.CORPORATE_ADDRESS_SET_BY_USER, body), onSuccess, onFail);
const deleteCorporateAddressSetByUser = async (onSuccess, onFail) => await callApi(client.delete(ENDPOINT.EL_CERT.CORPORATE_ADDRESS_SET_BY_USER), onSuccess, onFail);
const fetchCorporateAddressSetByUser = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.CORPORATE_ADDRESS_SET_BY_USER), onSuccess, onFail);

const checkAuthForEMS = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.ACCOUNTS.EMS_CHECK_AUTH), onSuccess, onFail);
const fetchEmsMenuList = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.OTHER.EMS_MENU), onSuccess, onFail);
const fetchAllEntries = async (entryStatus, entryManagementStatus, irregularStatus, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.EMS_ALL_ENTRIES(entryStatus || '', entryManagementStatus || '', irregularStatus || '')), onSuccess, onFail);
const fetchAllEntry = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.EMS_ALL_ENTRY(id)), onSuccess, onFail);
const fetchSHINSEI = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_SHINSEI(id)), onSuccess, onFail);
const fetchKeyPair = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_KEY_PAIR(id)), onSuccess, onFail);
const fetchElCert = async (id, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.ENTRY_EL_CERT(id)), onSuccess, onFail);
const fetchEncodedInvoice = async (id, to, onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.ENTRY_INVOICE(id, to)), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const changeStatusToDownloadAvailable = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_DOWNLOAD_AVAILABLE(id), body), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const changeStatusToApplyReady = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.ENTRY_MANAGEMENT_STATUS_APPLY_READY(id), body), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const changeStatusEnteringSerialNo = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.ENTRY_MANAGEMENT_STATUS_ENTERING_SERIAL_NO(id), body), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const changeIrregularStatus = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.IRREGULAR_STATUS(id), body), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const refund = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_REFUND(id), body), onSuccess, onFail);
// sample request
// {
//   "versionNo": 1"
// }
const ship = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_SHIP(id), body), onSuccess, onFail);
// sample request
// {
//   "status": "APPLY_FAILED",
//   "versionNo": 1"
// }
const updateEntryManagementStatus = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.ENTRY_MANAGEMENT_STATUS(id), body), onSuccess, onFail);
// sample request
// {
//   "memo": "hogehoge",
//   "versionNo": 1"
// }
const updateMemo = async (id, body, onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.ENTRY_MANAGEMENT_MEMO(id), body), onSuccess, onFail);
const createApplicationPdf = async (id, body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.EL_CERT.EMS_ALL_ENTRY_APPLICATION_PDF(id), body), onSuccess, onFail);
const searchAddressOnGoogleMap = async (placeName, onSuccess, onFail) => await callApi(client.get(ENDPOINT.OTHER.GOOGLE_MAP_ADDRESS_SEARCH(placeName)), onSuccess, onFail);

// sample request
// {
//   "title": "hogehoge",
//   "message": 1,
//   "startAt": "2020-07-22T00:00:00Z",
//   "endAt": "2020-04-27T00:00:00Z"
// }
const upsertOpsNotification = async (body, onSuccess, onFail) => await callApi(client.post(ENDPOINT.EL_CERT.OPS_NOTIFICATION, body), onSuccess, onFail);
const deleteOpsNotification = async (onSuccess, onFail) => await callApi(client.put(ENDPOINT.EL_CERT.OPS_NOTIFICATION_DELETE, {}), onSuccess, onFail);
const fetchOpsNotification = async (onSuccess, onFail) => await callApi(client.get(ENDPOINT.EL_CERT.OPS_NOTIFICATION), onSuccess, onFail);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  fetchStampSubmitter,
  searchCorporations,
  updateCompany,
  updateStampSubmitter,
  fetchCard,
  fetchShippingAddress,
  entry,
  notifyUserVoice,
  registerIssueInfo,
  fetchEntries,
  fetchEntry,
  fetchRegistryOffice,
  fetchPriceTable,
  refund,
  changeStatusToDownloadAvailable,
  changeStatusToApplyReady,
  changeStatusEnteringSerialNo,
  changeIrregularStatus,
  ship,
  searchAddressOnGoogleMap,
  upsertCorporateAddressSetByUser,
  deleteCorporateAddressSetByUser,
  fetchCorporateAddressSetByUser,
  fetchLoginAccount,
  logout,
  checkAuthForEMS,
  fetchEmsMenuList,
  fetchAllEntries,
  fetchAllEntry,
  fetchSHINSEI,
  fetchKeyPair,
  fetchElCert,
  fetchEncodedInvoice,
  updateEntryManagementStatus,
  updateMemo,
  createApplicationPdf,
  upsertOpsNotification,
  deleteOpsNotification,
  fetchOpsNotification,
};